export default function Experience() {
	return (
		<>
			<h1 className="mb-6 text-4xl font-bold">Experience</h1>
			<div className="space-y-16">
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2021-07-12">July '21</time> &ndash;
							<time>Present (Full-time employment)</time>
						</span>
					</div>
					<div>
						<h3>
							<div className="mx-auto my-12 h-[61px] w-[215px] max-w-xs">
								<svg
									width="215"
									height="61"
									viewBox="0 0 215 61"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M46.3758 11.5534C46.3342 11.2504 46.0695 11.0823 45.8498 11.064C45.6318 11.0457 41.3604 10.9808 41.3604 10.9808C41.3604 10.9808 37.7881 7.51175 37.4352 7.15885C37.0824 6.80596 36.3932 6.91249 36.1252 6.99239C36.1219 6.99406 35.4544 7.20047 34.3308 7.54837C34.1427 6.93913 33.8663 6.19005 33.4718 5.43765C32.2001 3.01066 30.3374 1.72725 28.0868 1.72393C28.0835 1.72393 28.0818 1.72393 28.0785 1.72393C27.922 1.72393 27.7672 1.73891 27.6108 1.75222C27.5442 1.67232 27.4776 1.59409 27.4077 1.51751C26.4272 0.468815 25.1705 -0.0422181 23.664 0.00272613C20.7576 0.0859563 17.8629 2.18502 15.5158 5.91373C13.8645 8.53714 12.6077 11.8331 12.2515 14.3849C8.91395 15.4186 6.58017 16.141 6.52857 16.1577C4.84399 16.687 4.79073 16.7386 4.571 18.3267C4.40787 19.5268 0 53.6113 0 53.6113L36.9392 60L52.9493 56.0199C52.9493 56.0199 46.4174 11.8564 46.3758 11.5534ZM32.4814 8.12099C31.6308 8.384 30.6636 8.68363 29.6149 9.00823C29.5933 7.53672 29.4185 5.48926 28.7327 3.71978C30.9383 4.1376 32.0236 6.63284 32.4814 8.12099ZM27.6823 9.60748C25.7464 10.2067 23.634 10.8609 21.515 11.5168C22.1109 9.23461 23.2412 6.96243 24.6295 5.47261C25.1455 4.9183 25.8679 4.30073 26.7235 3.94783C27.5275 5.62575 27.7023 8.00114 27.6823 9.60748ZM23.7222 1.93699C24.4047 1.92201 24.979 2.07183 25.4701 2.39476C24.6844 2.80259 23.9253 3.38853 23.2129 4.15258C21.3668 6.13346 19.9519 9.20798 19.3876 12.1743C17.6281 12.7186 15.9069 13.253 14.3222 13.7424C15.3227 9.07315 19.2361 2.06683 23.7222 1.93699Z"
										fill="#95BF47"
									/>
									<path
										d="M45.8514 11.0657C45.6334 11.0474 41.362 10.9825 41.362 10.9825C41.362 10.9825 37.7898 7.51344 37.4369 7.16055C37.3054 7.02904 37.1273 6.96079 36.9408 6.9325L36.9425 59.9984L52.951 56.02C52.951 56.02 46.4191 11.8581 46.3775 11.5551C46.3358 11.2521 46.0695 11.084 45.8514 11.0657Z"
										fill="#5E8E3E"
									/>
									<path
										d="M28.0668 19.2972L26.2075 26.2535C26.2075 26.2535 24.1334 25.3097 21.6748 25.4645C18.0692 25.6926 18.0309 27.9664 18.0676 28.5374C18.264 31.6485 26.4488 32.3277 26.9083 39.6153C27.2695 45.3482 23.867 49.27 18.9648 49.5796C13.0804 49.9508 9.84109 46.4801 9.84109 46.4801L11.0879 41.1767C11.0879 41.1767 14.3488 43.637 16.9589 43.4722C18.6635 43.364 19.2727 41.9774 19.2111 40.9969C18.9548 36.9386 12.2897 37.1783 11.8686 30.5099C11.514 24.8986 15.1995 19.2123 23.331 18.6996C26.4638 18.4982 28.0668 19.2972 28.0668 19.2972Z"
										fill="white"
									/>
									<path
										d="M74.0322 33.8637C72.1913 32.8648 71.2452 32.0228 71.2452 30.8654C71.2452 29.3927 72.5594 28.4466 74.6117 28.4466C77.0007 28.4466 79.1338 29.4455 79.1338 29.4455L80.8162 24.291C80.8162 24.291 79.2692 23.0808 74.7157 23.0808C68.379 23.0808 63.9873 26.7097 63.9873 31.8114C63.9873 34.704 66.0379 36.9131 68.7736 38.4898C70.9827 39.7512 71.7719 40.6461 71.7719 41.9603C71.7719 43.3274 70.6674 44.4319 68.6168 44.4319C65.5607 44.4319 62.6747 42.8535 62.6747 42.8535L60.8867 48.008C60.8867 48.008 63.5531 49.7961 68.0389 49.7961C74.5605 49.7961 79.2412 46.5881 79.2412 40.8029C79.2395 37.7023 76.8736 35.4932 74.0322 33.8637Z"
										fill="currentColor"
									/>
									<path
										d="M100.013 23.0296C96.8048 23.0296 94.2804 24.5552 92.3355 26.8683L92.2298 26.8154L95.0167 12.2484H87.7588L80.7122 49.3239H87.9701L90.3889 36.6506C91.3349 31.8643 93.8065 28.9205 96.1213 28.9205C97.7508 28.9205 98.3832 30.025 98.3832 31.6034C98.3832 32.6023 98.2775 33.8125 98.0678 34.8114L95.3337 49.3256H102.592L105.431 34.3375C105.747 32.7591 105.958 30.8671 105.958 29.604C105.955 25.5012 103.799 23.0296 100.013 23.0296Z"
										fill="currentColor"
									/>
									<path
										d="M122.363 23.0296C113.632 23.0296 107.849 30.9183 107.849 39.7001C107.849 45.3268 111.319 49.849 117.841 49.849C126.413 49.849 132.198 42.1717 132.198 33.1785C132.198 27.9728 129.147 23.0296 122.363 23.0296ZM118.787 44.2767C116.315 44.2767 115.263 42.1733 115.263 39.5432C115.263 35.3892 117.42 28.6052 121.364 28.6052C123.941 28.6052 124.781 30.8142 124.781 32.9705C124.781 37.4398 122.627 44.2767 118.787 44.2767Z"
										fill="currentColor"
									/>
									<path
										d="M150.762 23.0296C145.863 23.0296 143.083 27.3421 143.083 27.3421H142.979L143.4 23.4506H136.984C136.669 26.0807 136.089 30.0762 135.512 33.0745L130.463 59.6313H137.721L139.718 48.9029H139.877C139.877 48.9029 141.366 49.849 144.137 49.849C152.656 49.849 158.23 41.12 158.23 32.2837C158.23 27.395 156.073 23.0296 150.762 23.0296ZM143.82 44.3807C141.936 44.3807 140.821 43.329 140.821 43.329L142.031 36.545C142.873 32.0228 145.239 29.0245 147.764 29.0245C149.973 29.0245 150.656 31.0751 150.656 33.0217C150.656 37.7023 147.869 44.3807 143.82 44.3807Z"
										fill="currentColor"
									/>
									<path
										d="M168.59 12.6166C166.277 12.6166 164.436 14.4575 164.436 16.8234C164.436 18.9797 165.803 20.4524 167.854 20.4524H167.959C170.221 20.4524 172.166 18.9268 172.219 16.2456C172.219 14.1421 170.799 12.6166 168.59 12.6166Z"
										fill="currentColor"
									/>
									<path
										d="M158.441 49.3239H165.697L170.642 23.6091H163.331L158.441 49.3239Z"
										fill="currentColor"
									/>
									<path
										d="M189.101 23.5563H184.052L184.314 22.3461C184.735 19.8745 186.208 17.6654 188.627 17.6654C189.918 17.6654 190.94 18.0336 190.94 18.0336L192.36 12.3541C192.36 12.3541 191.098 11.7234 188.415 11.7234C185.838 11.7234 183.263 12.4597 181.316 14.1421C178.844 16.2456 177.687 19.295 177.109 22.3461L176.9 23.5563H173.533L172.481 29.0262H175.848L172.009 49.3256H179.267L183.106 29.0262H188.102L189.101 23.5563Z"
										fill="currentColor"
									/>
									<path
										d="M206.56 23.6092C206.56 23.6092 202.023 35.0392 199.986 41.2785H199.88C199.742 39.2692 198.092 23.6092 198.092 23.6092H190.466L194.833 47.2205C194.939 47.7456 194.886 48.0626 194.675 48.4307C193.832 50.0603 192.413 51.6387 190.73 52.7961C189.363 53.7949 187.838 54.4256 186.629 54.8466L188.627 61C190.1 60.6847 193.149 59.4745 195.726 57.0557C199.04 53.9534 202.089 49.1671 205.244 42.6455L214.132 23.6075H206.56V23.6092Z"
										fill="currentColor"
									/>
								</svg>
							</div>
						</h3>
						<p>
							<em>Shopify</em> is a complete commerce platform that lets you
							start, grow, and manage a business. The platform services millions
							of merchants worldwide and supports commerce across a myriad of
							channels from web stores to social media.
						</p>

						<h3>Currently:</h3>

						<p>
							Working on the Shopify Collabs team - building out a React Native
							app to enable Content Creators to effectively partner and
							collaborate with relevant merchants to increase reach and targeted
							sales.
						</p>

						<h3>Previously:</h3>

						<ul className="list-disc space-y-1 pl-5">
							<li>Worked in the Shop group as Senior IC.</li>
							<li>
								Part of the team who brought Shop to the web at{' '}
								<a href="https://shop.app"> https://shop.app</a> using Remix,
								integrating with AI.
							</li>
							<li>
								Initially worked on Activation team for the native Shop (React
								Native) app ensuring users onboarded effectively.
							</li>
						</ul>

						<h3>Other:</h3>

						<ul className="list-disc space-y-1 pl-5">
							<li>
								Project ideation, planning, leadership and implementation.
							</li>
							<li>Providing mentorship through company-wide program.</li>
							<li>
								Helping to source and interview engineering candidates for roles
								across Shopify.
							</li>
						</ul>
					</div>
				</section>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2016-01-01">Jan '16</time> &ndash;
							<time dateTime="2021-06-30">June '21</time>
						</span>
					</div>
					<div>
						<h3>
							<img
								src="img/logos/canonical.svg"
								alt="Canonical logo"
								className="mx-auto my-12 max-w-xs"
							/>
						</h3>
						<p>
							<em>Canonical</em> is best known as the company that delivers{' '}
							<a
								href="https://ubuntu.com/"
								target="_blank"
								rel="noreferrer noopener"
								className="text-blue-600 underline"
							>
								Ubuntu
							</a>{' '}
							- an open source software platform that runs everywhere.
						</p>
						<p>
							I worked at Canonical to support the web offering in the front-end
							space across multiple product streams.
						</p>
						<ul className="list-disc space-y-1 pl-5">
							<li>
								I co-led development on greenfield rebuild of flagship dashboard
								product, JAAS Dashboard, using React/Redux.
							</li>
							<li>
								I previously led the rewriting and adoption of company-wide UI
								framework,{' '}
								<a
									href="https://vanillaframework.io/"
									target="_blank"
									rel="noreferrer noopener"
									className="text-blue-600 underline"
								>
									Vanilla Framework
								</a>
								, which is now used on 60+ sites and products internally.
							</li>
							<li>
								Speared-headed visual regression testing initiative,
								significantly improving stability.
							</li>
							<li>
								Web Performance advocate, organising regular workshops, targeted
								sprints and driving automated visibility of performance issues
								through CI/CD.
							</li>
							<li>Line managed, mentored and supported developers.</li>
							<li>
								I was co-located in the London office before moving full-time
								remote in late 2016.
							</li>
						</ul>
					</div>
				</section>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2015-10-16">Oct</time> &ndash;
							<time dateTime="2015-12-18">Dec 2015 (Short-term contract)</time>
						</span>
					</div>
					<div>
						<h3>
							<div className="m-auto h-[47px] w-[249px]">
								<svg
									className="mx-auto my-12 max-w-xs"
									width="249"
									height="47"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g fill="currentColor" fill-rule="evenodd">
										<path d="M246.27 5.077c0 .138.139.277.139.415.276 1.38-.553 2.9-1.105 4.143l-1.243 2.487c-.415.828-.829 1.38-1.381 2.071-.553.691-1.105 1.658-1.382 2.487-.414.966-.69 1.795-.967 2.762-.414 1.105-1.104 2.21-1.657 3.315-.552 1.243-.829 2.486-1.52 3.73-.276.414-.552.828-.966.966-.415.138-.967.138-1.381-.138-.691-.553-.415-1.381-.277-2.072.277-.829.691-1.657.967-2.348.415-1.105.967-2.21 1.52-3.177.552-1.105 1.38-1.933 1.519-3.315.138-1.243-.414-2.072-.69-3.176-.277-1.244-.415-2.625-.83-3.868-.276-.967-1.795-3.867-.138-4.282 1.382-.414 1.934 2.072 2.21 3.039.415 1.381.691 2.9.967 4.282 0 .276.415.276.553.138a19.162 19.162 0 0 0 2.9-5.525c.277-.69.277-1.52.829-1.934.276-.69 1.52-.69 1.934 0M228.177 8.254c.276 1.381-.415 3.315-.829 4.696-.552 1.796-1.381 3.591-2.486 5.11a13.946 13.946 0 0 1-1.796 2.21c-.552.691-1.38 1.52-2.21 1.796-1.38.415-1.933-.69-2.348-1.657-.414-1.243-.69-2.486-1.105-3.73-.138-.69-.414-1.38-.69-1.933-.138-.415-.415-1.52-.967-.967-.138.138-.276.414-.276.552-.139.553-.277.967-.415 1.52-.414 1.657-.69 2.9-1.105 4.282-.276 1.105-.552 2.21-.828 3.176-.139.691-.415 2.348-.967 2.625-.553.276-1.243-.277-1.52-.69-.414-.83-.138-1.935 0-2.763.415-1.934.967-3.868 1.52-5.94.552-1.795 1.38-3.59 1.657-5.524.138-.691.276-1.52.967-1.796.69-.414 2.072 0 2.486.552.69.83 2.072 5.94 2.625 7.459.138.414.276 2.348 1.104 1.658.277-.277 1.105-1.796 1.382-2.21.69-1.105 1.243-1.934 1.795-3.177.553-1.243.69-2.625.967-3.868.276-.966.69-2.9 2.072-2.348.69.138.829.553.967.967M174.31 11.293l.414.414c.414.553.552 1.243.828 1.934.139.276.691 3.73.83 4.696 0 .138.137.276.275.138.415-.138.553-.552.967-.967.829-.828 1.658-1.795 2.486-2.624.691-.829 1.382-2.21 2.349-2.762.828-.415 1.933-.139 2.21.552.276.553.276 1.243.276 1.934 0 1.105-.138 2.348-.276 3.453-.139.829-.139 1.657-.277 2.348 0 .69 0 1.52-.138 2.21-.138.552-.276 1.243-.552 1.657-.415.553-.967.138-1.382-.276-.966-.967-.552-2.762-.276-3.867.138-.691.276-1.52.415-2.21 0-.277 0-.553.138-.83 0-.275.138-.966-.138-1.242-.415-.276-1.382.967-1.52 1.105-.552.552-1.105 1.105-1.52 1.795-.413.553-.966 1.243-1.38 1.796-.415.414-.967 1.243-1.52 1.381-1.38.276-2.21-1.52-2.348-2.486-.138-.829-.276-1.657-.276-2.348 0-.553 0-1.105-.138-1.658 0-.276 0-.552-.276-.552-.138-.138-.415 0-.553.138-.69.414-.829 1.243-1.243 1.934-.414.829-.829 1.657-1.105 2.486-.552 1.243-1.105 2.624-1.657 3.867-.277.691-.553 1.243-.967 1.934l-.829 1.658a1.415 1.415 0 0 1-.829.69c-.69.276-1.38-.276-1.38-.967-.139-.552.275-.967.413-1.519.553-1.381 1.52-2.762 2.21-4.144.83-1.795 1.52-3.59 2.349-5.386.552-1.244 1.243-2.487 2.071-3.592.277-.414.69-.966 1.243-1.105.139-.138.691.139 1.105.415M144.475 11.017c-.967 2.9-2.486 5.386-3.73 8.01-.69 1.52-1.242 3.177-1.795 4.697-.414 1.52-.414 3.453-1.105 4.834-.138.414-.414 1.243-.967 1.243-.552 0-1.933.414-1.519-1.52.138-.414.276-1.104.276-1.519.277-.966.415-1.933.691-2.9.276-1.105.552-2.21.552-3.315s-.552-2.21-1.105-3.177c-.552-.967-1.38-1.934-1.933-2.9-.276-.553-.553-.967-.69-1.52v-.276c.137-.276.552-.138.828-.138.276 0 .69 0 .967.276.552.276.828 1.105 1.105 1.52.414.69.828 1.38 1.243 2.21.138.138.69 1.243.967 1.795 0 .138.276.138.276 0 .414-.69 1.105-2.486 1.381-3.039.414-.828.829-1.657 1.243-2.348.138-.414.69-1.795.967-2.072.276-.414.829-.828 1.105-.828 1.381 0 1.381.552 1.243.967M91.022 13.088c.276.415.414 1.52-.138 1.796h-.276c-2.348 0-4.835.276-7.183.414-.138 0-.276.138-.414.277-.69 2.071-.967 4.143-1.52 6.215-.137.276.139.553.415.553h.414c.415 0 .83-.139 1.244-.139.69 0 1.519 0 2.071.415.415.276.415.69.277 1.105-.139.552-.553.69-1.105.828-.553.139-1.243.139-1.796.277h-1.243c-.276 0-.69-.138-.967.138-.138.138-.138.414-.276.552-.138.83-.276 1.52-.415 2.487 0 .414-.138 1.104.277 1.243 1.52 0 3.177.138 4.696 0 .552 0 1.381-.277 1.795 0 .277.138.277.414.277.69v.415c-.138.276-.277.276-.553.414-.276.138-.552.138-.829.276-.552.138-1.104.276-1.657.276-1.105.139-2.21.139-3.453.139h-1.52c-.276 0-.414 0-.69-.139-.276-.138-.414-.414-.414-.552-.277-.829 0-1.796.138-2.624.276-.967.829-2.21.69-3.315 0-.277-.276-.415-.276-.69a.88.88 0 0 1 0-.83c.138-.276.415-.552.69-.69.139-.138.277-.138.415-.276.138-.139.414-1.658.414-2.072.277-1.243.415-2.486.553-3.868 0-.69.138-1.38.138-2.072 0-.552.138-1.104.553-1.519.276-.276.966-.276 1.38-.276 1.244 0 2.349 0 3.592-.138.829 0 1.52-.138 2.348-.138.967.138 1.934.138 2.348.828M201.796 17.508c0 .69 0 1.243-.691 1.52-.138 0-.276.138-.414.138-.691.138-1.382.138-1.934.276-.414 0-2.072.276-1.658-.552.139-.277.415-.415.553-.691.138-.276.414-.69.552-.967.415-.69.83-1.243 1.105-1.934.277-.414.553-.967.83-1.38.137-.277.413-.83.69-.83 1.105-.138.967 3.453.967 4.42zm2.624 1.934c0-1.52-.138-3.039-.414-4.42-.277-1.657-.691-3.177-.83-4.696 0-.414-.137-.829-.552-1.105-.414-.276-1.105-.138-1.519 0-.69.276-1.243 1.243-1.52 1.934-.69 1.105-1.104 2.072-1.795 3.176-.829 1.105-1.52 2.349-2.348 3.454-.967 1.38-1.657 3.038-2.624 4.42-.553.828-1.243 1.38-1.658 2.21-.276.414-.414 1.104-.138 1.519.276.276.69.414.967.414h.69c.277-.138.553-.414.83-.69.414-.691.828-1.52 1.242-2.21.277-.415.415-.691.83-.967.413-.277 1.242 0 1.657 0 1.105 0 2.21-.277 3.314-.69.277-.14.83-.553 1.105-.277.139.138.139.138.139.276.138.69.138 1.52 0 2.21 0 .414-.415.967-.139 1.381.139.276.415.276.553.415.414 0 .967 0 1.381-.139.69-.414.553-1.657.553-2.348.138-1.519.276-2.624.276-3.867zM18.094 26.624c0 .138.138.138.138 0 1.243-1.519 2.072-3.176 3.177-4.696 1.243-1.795 2.762-2.9 4.42-4.42.414-.276 1.105-.967 1.657-.828.276 0 .415.276.553.414.414.829.552 2.072.552 3.177.138 1.105.138 2.072.138 3.177 0 2.21-.138 4.42-.138 6.491 0 1.105 0 2.21.138 3.177 0 .69-.138 1.657-.967 1.934-.138.138-.414.138-.552.138-.414-4.834-.138-16.298-.553-16.16-.828-.138-4.143 3.59-5.8 6.077-.553.967-.967 1.934-1.52 2.762-.276.415-.552.83-.829 1.105-.276.277-1.105.83-1.38.415-.415-.553-.553-1.658-.553-2.348-.277-1.796-.277-3.591-.553-5.387-.138-.967-.276-2.072-.69-3.039-.139-.276-.139-.414-.415-.138-.138.138-.276.415-.414.69-.829 1.106-.829 2.487-1.105 3.73-.276 1.105-.553 2.072-.967 3.039-.829 2.21-2.072 4.143-3.039 6.215-.138.138-.138.276-.276.415-.138.138-.276.138-.414.138-.553-.277.276-2.072.414-2.487.414-.828.829-1.657 1.243-2.624.829-1.934 1.381-4.005 2.072-6.077.69-2.072 1.381-4.006 2.762-5.663l.415-.415c.967-.276 1.52 1.934 1.795 2.487.415 1.519.553 3.176.69 4.834 0 .69.139 1.381.139 2.072-.276.414-.276 1.38-.138 1.795M49.724 23.724c-49.586-53.73-.138 0 0 0-.138.138-.276.138-.415.138H47.1c-.69 0-2.071.138-2.071-.138-.138-.276.414-.829.552-1.105.414-.415.69-.829.967-1.381.552-.83 1.243-1.796 1.796-2.763.138-.138.828-1.52.966-.69.139.552.139 1.38.139 1.933 0 1.243.138 2.625.138 3.868.138 0 .138 0 .138.138zm2.21 5.525c-.277-2.21-.415-4.42-.553-6.63-.138-1.243-.138-2.625-.138-3.868 0-1.38.138-2.762-.414-4.143-.415-1.105-1.105 0-1.52.414-.414.553-.966 1.105-1.38 1.658a32.131 32.131 0 0 0-2.349 3.59 50.9 50.9 0 0 1-2.348 3.454c-.829-.138-1.243.276-1.381.967-.138.414-.138.828-.276 1.243-.277.828-.691 1.519-1.244 2.348-.552.828-1.104 1.795-1.657 2.762-.552 1.105-1.105 2.072-.69 3.177.966 0 1.243-.967 1.657-1.657a85.74 85.74 0 0 1 1.795-3.454c.277-.552.691-1.104.967-1.519.277-.276.553-1.105.967-1.243.138 0 .276 0 .415-.138 2.071-.138 4.143-.276 6.215-.276.138 0 .276.138.276.138.415 1.52-.414 6.492.967 6.768 1.381.414.829-2.763.69-3.591z" />
										<path d="M248.204 31.32c-.966.967-2.762.691-4.143.83-3.591.552-7.044.966-10.636 1.519-6.491.966-12.845 1.933-19.337 2.762-6.077.829-12.154 2.348-18.232 2.9-5.11.553-10.22.691-15.331.415-5.11-.276-10.083.276-15.332.829-9.392.828-18.922 1.105-28.453.966-8.287-.138-16.436.553-24.723.277-7.597-.277-15.332.276-22.929.276h-8.563c-7.873.138-15.608.829-23.48.829-8.012 0-16.023-.138-23.896.69-2.21.277-5.248.138-6.906.415-1.243.138-2.486.552-3.73.69-3.728.415-7.182-.138-10.91.967-1.106.276-2.21.69-3.316.69-1.105 0-2.21.415-3.315.415s-1.933-.414-3.038-.552c-.553 0-1.243-.277-1.658-.691C0 45.271 0 44.718 0 44.442c0-2.21.138-4.42.138-6.63.69-.829.967-1.381 2.072-1.381.829 0 1.796.414 2.624.138.829-.138 1.658-.552 2.348-.69.415-.139.967.138 1.382 0 4.972-.83 10.22-.967 15.193-1.382 5.801 0 11.602-1.243 17.403-1.52 5.801-.275 11.602 0 17.265.139 4.144 0 8.288-.552 12.431-.69 5.249-.277 10.498 0 15.746-.139 5.387-.138 10.774-.552 16.16-.552 6.354-.138 12.708.414 19.2 0 7.32-.553 14.64-.415 21.96-.276 6.492.138 12.984.414 19.338-.967 6.353-1.243 12.569-.69 19.06-.69 4.973 0 9.945 0 14.918-.553 1.795-.139 3.453-.83 5.248-1.105 1.658-.277 3.315-.415 4.973-.691 4.143-.829 8.149-1.381 12.292-1.796 2.072-.276 4.144-.69 6.216-.828.829 0 1.657 0 2.486-.277.829-.138 1.657-.69 2.486-.69 2.763-.138 5.525-1.243 9.116-1.105 1.243 0 4.144-.276 5.249-.69 2.9-.968 3.315 3.176 3.315 5.11 0 1.105.138 2.762-.415 3.73.139.137.139.275 0 .413" />
										<path d="M69.06 20.409c-.275 3.177-2.347 7.044-5.386 8.563-.552.277-1.105-.138-1.105-.69 0-1.52.138-3.039.414-4.558.415-1.796.967-3.591 1.244-5.387.276-1.105.552-2.624 1.38-3.453.277-.276.691-.553 1.244-.414 1.243.276 1.381 1.243 1.795 2.21.415 1.243.553 2.486.415 3.729zm.553-5.94c-.552-.828-1.52-1.795-2.9-1.795-1.382 0-2.625.138-3.315 2.21-.276.69-.276 1.657-.553 2.486-.276 1.105-.414 2.21-.552 3.315-.553 2.21-.967 4.558-1.381 6.768-.139.553-.139 1.243-.277 1.796 0 .414-.276 1.243-.276 1.519.276.829 1.52 1.381 2.348 1.243.967-.138 2.072-1.243 2.9-1.796 2.21-1.933 4.559-4.42 5.25-7.32.414-2.9.276-6.077-1.244-8.425zM122.652 26.072c-.138.69-.69 1.105-1.658 1.105-.828.138-1.519.138-2.348-.138-.138 0-.276-.138-.414-.138-.138-.139-.138-.277-.138-.553v-.967c0-.552.138-.967.276-1.52 0-.275 0-.552.138-.828 0-.414.138-1.105.138-1.105h.553c.414 0 .552.138.829.138.552.138 1.105.553 1.519.829.552.553.829 1.52.967 2.348.138.276.138.553.138.829zm-3.177-8.011c-.138-.138-.276-.415-.276-.553.138-.828.276-1.519.414-2.21.138-.552.415-.967.69-1.38v-.139c.277-.414.415-.552.83-.552h.828c.83 0 1.243.138 1.52.414.138.138.276.414.276.552v.415c0 .828-.276 1.52-.829 2.21-.552.69-1.381 1.105-2.486 1.38-.414.139-.829.139-.967-.137zm6.216-2.348c.138-.829 0-1.658-.277-2.486-.138-.415-.414-.967-.828-1.244-.138 0-.138-.138-.277-.138-.828-.414-2.071-.414-2.486-.414-2.762 0-3.315 1.796-4.143 4.834-.139.69-.415 1.243-.553 1.796-.138.138-.138.414-.276.552-.276.829-.276 1.796-.138 2.763v.138c0 .552.138 1.243 0 1.795 0 .277-.138.553-.138.83 0 .275-.139.552-.139.828 0 .276 0 .552-.138.829-.138 1.105-.276 2.21.138 3.453.139.276.415.414.691.552.553.138 1.243.138 1.796.138 2.624 0 4.696-.967 5.663-2.762 1.105-1.934.276-4.42-1.934-6.354l-.276-.276.414-.276c1.243-.69 2.624-2.625 2.9-4.558z" />
									</g>
								</svg>
							</div>
						</h3>
						<p>
							<em>Made by Many</em> is an award winning innovation accelerator
							based in Angel. I worked with them over 5 two-week sprints to
							develop a complex Ruby on Rails product with an accompanying
							Pattern Library for a leading scientific laboratory.
						</p>
						<p>
							The lab was a large corporate with multiple competing sub-brands
							so the challenge was to develop an over-arching set of patterns &
							living components that could be thread through multiple products
							to build a cohesive overall brand.
						</p>
						<ul className="list-disc space-y-1 pl-5">
							<li>
								Joined an established team to help build a research application
								for leading Cambridge laboratory using Rails in a challenging
								ten-week timeframe.
							</li>
							<li>
								I led an initiative to abstract common UI components to produce
								an accompanying Pattern Library, allowing us to quickly respond
								to user and A/B testing.
							</li>
						</ul>
					</div>
				</section>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2015-02-04">Feb</time> &ndash;
							<time dateTime="2015-10-16">Oct 2015 (Medium-term contract)</time>
						</span>
					</div>
					<div>
						<h3>
							<div className="mx-auto my-12 max-w-xs">
								<svg
									width="250"
									height="87"
									xmlns="http://www.w3.org/2000/svg"
									className="text-foreground dark:text-white"
								>
									<g fill="currentColor" fillRule="evenodd">
										<path d="M128.836 30.126c-10.641.187-19.79 9.218-20.435 20.168-.645 10.95 7.983 20.74 19.27 21.866 11.29 1.122 20.438-7.91 20.438-20.17-.002-12.265-8.628-22.053-19.273-21.864zm1.324 31.695c-5.853.689-10.837-4.663-10.5-11.477.332-6.817 3.058-11.077 8.577-11.193 5.519-.117 8.858 6.221 8.229 13.63-.483 5.673-3.997 8.767-6.306 9.04zM150.174 53.109c0 12.263 9.147 21.294 20.437 20.17 11.288-1.124 19.916-10.914 19.273-21.865-.644-10.95-9.796-19.983-20.44-20.17-10.642-.187-19.27 9.603-19.27 21.865zm11.643.792c-.63-7.41 2.71-13.746 8.229-13.63 5.52.114 8.244 4.374 8.578 11.19.336 6.814-4.65 12.165-10.502 11.476-2.309-.27-5.82-3.364-6.305-9.036zM0 77.59V14.634l13.189-3.384-.033 26.82L35.43 16.59l11.455 4.402L30.697 38.95l10.736 39.111H29.786l-8.591-29.966-8.115 7.947.109 22.02L0 77.59zM90.824 50.13c-.003-.11.008.135 0 0 .008.13-.003-.115 0 0z" />
										<path d="M90.824 50.13c-.003-.09.008.091 0 0 .008.09-.003-.094 0 0z" />
										<path d="M90.824 50.13c-.01-.235.016.292 0 0 .016.269-.011-.254 0 0z" />
										<path d="M90.824 50.13c-.001-.042.002.04 0 0 .002.042-.001-.042 0 0z" />
										<path d="M90.824 50.13c.008.131.008.118 0 0z" />
										<path d="M90.824 50.13c-.003-.134.012.204 0 0 .014.221-.003-.128 0 0z" />
										<path d="M90.824 50.13c-.001-.046.006.082 0 0 .006.078-.001-.048 0 0z" />
										<path d="M90.824 50.13c-.007-.18.012.2 0 0 .014.21-.005-.17 0 0z" />
										<path d="M90.824 50.13c-.007-.216.012.202 0 0 .014.221-.007-.199 0 0z" />
										<path d="M90.824 50.13c-.001-.03 0 0 0 0 .002.015-.001-.015 0 0z" />
										<path d="M90.824 50.13c-.001-.06.002.038 0 0 .004.05-.001-.05 0 0z" />
										<path d="M90.824 50.13c-.001-.02.002.017 0 0 .002.013-.001-.023 0 0z" />
										<path d="M90.824 50.13c-.003-.098.008.097 0 0 .006.082-.003-.117 0 0z" />
										<path d="M90.824 50.13c-.017-.37.023.437 0 0 .02.328-.02-.46 0 0z" />
										<path d="M90.824 50.13c-.001-.044.002.038 0 0 .002.042-.001-.042 0 0z" />
										<path d="M96.313 73.195h11.58l-4.355-30.825c-1.647-18.004-8.214-18.046-20.47-14.13L82.816 0 71.544 3.011l1.796 69.8 11.07.382-.64-36.065c2.425-1.073 10.442-3.33 10.71 5.559l1.073 12.678.76 17.83zM235.931 73.557l-3.269 7.699 6.92 4.83 6.823-4.08-2.874-8.449h-7.6zM187.803 25.628l1.897 13.1h7.928l.55 31.157s-1.24 11.21 15.652 8.644c0 0 5.286-1.584 5.118-5.323v-12.31s-3.559 2.129-7.427 2.129c-3.868 0-3.893-1.888-3.893-1.888l-1.034-24.131 12.354-.69v-7.929l-12.648-.834.154-16.33-8.798-3.647-.011 18.395-9.842-.343zM226.687 6.887L250 11.377l-9 57.806-14.313-62.296zM44.084 28.656l3.088 8.151c7.66-4.652 11.988.02 11.988.02l-.059 5.202c-22.826 4.045-17.051 25.4-17.051 25.4 2.309 8.38 9.824 8.09 9.824 8.09l17.115.002.324-38.857c-2.681-18.088-25.229-8.008-25.229-8.008zm14.992 39.43s-8.278 2.027-9.192-6.13c0 0 .177-12.624 9.503-11.267l-.31 17.397z" />
									</g>
								</svg>
							</div>
						</h3>
						<p>
							<em>Kahoot!</em> is a real-time quiz collaboration platform
							experiencing huge growth.
						</p>
						<p>
							I worked with <em>Kahoot!</em> over an eight-month period to
							provide guidance and direction on improving their front end
							architecture for scalability and modularity in the future. This
							involved:
						</p>
						<ul className="list-disc space-y-1 pl-5">
							<li>
								Architecting a new modular CSS framework to style entire product
								using Atomic Design principles.
							</li>
							<li>
								Creating documentation repository to outline conventions, best
								practices and linting rules.
							</li>
							<li>Switching the development team from using LESS to SASS.</li>
							<li>
								Building out a Pattern Library from the ground up using
								Fabricator.
							</li>
							<li>
								Educating and guiding the development team on style guide driven
								development.
							</li>
							<li>Helping the development team transition to Scrum.</li>
							<li>
								Rebuilding the marketing website as a full stack developer.
							</li>
						</ul>
					</div>
				</section>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2014-12-01">Dec '14</time> &ndash;
							<time dateTime="2015-01-28">Jan '15 (Short-term contract)</time>
						</span>
					</div>
					<div>
						<h3>
							<img
								src="img/logos/nuffield.svg"
								alt="Nuffield Health logo"
								className="mx-auto my-12 max-w-xs"
							/>
						</h3>
						<p>
							I developed a microsite for <em>Nuffield Health</em> to support
							their new year media & print campaigns. The site was built on
							NodeJS & included Salesforce integration for CRM and Google Maps
							integration for an interactive location finder of Nuffield
							Hospitals by postcode.
						</p>
					</div>
				</section>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2013-07-28">Jul '13</time> &ndash;
							<time dateTime="2014-11-28">Nov '14 (Long-term contract)</time>
						</span>
					</div>
					<div>
						<h3>
							<div className="mx-auto my-12 max-w-xs">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 1190.6 680.3"
								>
									<g fill="currentColor">
										<path d="M547.5 234.1H600v21.6h-52.5v57.5h-22.9V179.6h79.2v21.6h-56.3v32.9zM651.4 315.5c-4.3 0-8.5-.8-12.5-2.3-4-1.5-7.5-3.8-10.6-6.7-3.1-2.9-5.5-6.5-7.3-10.7-1.9-4.2-2.8-9-2.8-14.5v-58.6h22.9V275c0 6.7 1.5 11.6 4.6 14.6 3.1 3 7.5 4.5 13.4 4.5 2.9 0 5.5-.6 7.7-1.7s4.1-2.4 5.6-3.8c1.8-1.5 3.3-3.4 4.6-5.5v-60.3h22.9v90.5h-21.4V300c-1.9 2.9-4.1 5.5-6.7 7.8-2.2 1.9-4.9 3.7-8.4 5.2-3.4 1.7-7.4 2.5-12 2.5zM715 222.7h17.7v-26.9h22.9v26.9H783v20.6h-27.3v36.5c0 2.8.3 5.1 1 7 .6 1.8 1.5 3.3 2.7 4.4 1.1 1.1 2.4 1.8 3.8 2.3 1.4.4 2.9.7 4.4.7 1.3 0 2.5-.2 3.6-.5s2.2-.7 3.1-1.1c1-.5 2-1.1 2.9-1.7l8.4 18.7c-1.6 1.1-3.6 2.2-5.9 3.1-1.9.8-4.2 1.4-6.8 2-2.7.6-5.7.9-9 .9-4.5 0-8.6-.8-12.3-2.3-3.7-1.5-7-3.7-9.7-6.5-2.7-2.8-4.9-6.2-6.5-10.1-1.6-3.9-2.4-8.4-2.4-13.2v-40.1h-18v-20.7zM832.5 315.5c-4.3 0-8.5-.8-12.5-2.3-4-1.5-7.5-3.8-10.6-6.7-3-2.9-5.5-6.5-7.3-10.7-1.8-4.2-2.8-9-2.8-14.5v-58.6h22.9V275c0 6.7 1.5 11.6 4.6 14.6 3.1 3 7.5 4.5 13.4 4.5 2.9 0 5.5-.6 7.7-1.7s4.1-2.4 5.6-3.8c1.8-1.5 3.3-3.4 4.6-5.5v-60.3H881v90.5h-21.4V300c-1.9 2.9-4.1 5.5-6.7 7.8-2.1 1.9-4.9 3.7-8.4 5.2-3.4 1.7-7.4 2.5-12 2.5zM948.3 220.4c2 0 4 .2 5.9.5 1.9.3 3.6.7 5 1.1 1.7.5 3.2 1 4.8 1.3l-8 20.6c-.8-.3-1.7-.6-2.9-1-1-.2-2.2-.5-3.5-.8-1.3-.3-2.8-.4-4.5-.4-3.6 0-6.6.7-9.1 1.9-2.5 1.3-4.6 2.7-6.2 4.2-1.9 1.8-3.6 3.8-5 6.1v59.2h-22.9v-90.5h21.8v13.2c1.7-2.8 3.6-5.4 5.9-7.6 2-1.9 4.6-3.7 7.7-5.3 3.1-1.7 6.8-2.5 11-2.5zM1009.7 220.4c6.2 0 12.1 1.2 17.7 3.4 5.5 2.3 10.3 5.5 14.5 9.6 4.1 4.1 7.4 9.1 9.8 14.9 2.4 5.8 3.6 12.2 3.6 19.2v3.6c0 1.5-.1 3.2-.2 4.9h-67.6c.4 2 1.3 4.2 2.7 6.3 1.4 2.2 3.2 4.1 5.3 5.9 2.1 1.8 4.7 3.3 7.6 4.4 2.9 1.2 6.2 1.7 9.7 1.7 3.9 0 7.4-.5 10.5-1.4 3.1-.9 5.7-2 7.8-3.1 2.4-1.4 4.6-2.9 6.5-4.6l11.5 17.2c-2.9 2.4-6.2 4.6-9.9 6.5-3.2 1.7-7 3.1-11.5 4.5-4.4 1.3-9.4 2-14.9 2-6.9 0-13.3-1.2-19.2-3.7-5.9-2.5-11.1-5.9-15.5-10.1-4.4-4.3-7.8-9.3-10.3-15.1-2.5-5.8-3.7-12-3.7-18.6 0-6.6 1.1-12.8 3.4-18.6 2.3-5.8 5.4-10.8 9.4-15.1 4-4.3 8.8-7.6 14.4-10.1 5.9-2.5 11.9-3.7 18.4-3.7zm22.7 39.1c-.1-1.9-.7-3.9-1.6-6.1-1-2.2-2.4-4.2-4.2-6-1.8-1.8-4.2-3.3-7-4.5-2.8-1.1-6.1-1.7-9.9-1.7-3.7 0-6.9.6-9.5 1.7-2.7 1.1-4.9 2.6-6.8 4.4-1.8 1.8-3.2 3.8-4.2 5.9-.9 2.1-1.5 4.3-1.6 6.3h44.8zM524.6 360.1h22.9v119.1h56.9v21.6h-79.8V360.1zM656.6 408c6.2 0 12.1 1.1 17.6 3.4 5.5 2.3 10.4 5.5 14.5 9.6s7.4 9.1 9.8 14.9c2.4 5.8 3.6 12.2 3.6 19.2v3.6c0 1.5-.1 3.2-.2 4.9h-67.5c.4 2 1.3 4.1 2.7 6.3 1.4 2.2 3.2 4.1 5.3 5.9 2.1 1.8 4.7 3.2 7.6 4.4 2.9 1.2 6.2 1.7 9.7 1.7 3.9 0 7.4-.5 10.5-1.4 3.1-1 5.7-2 7.8-3.1 2.4-1.4 4.6-2.9 6.5-4.6L696 490c-2.9 2.4-6.2 4.6-9.9 6.5-3.2 1.6-7 3.1-11.4 4.5-4.5 1.3-9.4 2-14.9 2-6.9 0-13.2-1.2-19.2-3.7-5.9-2.5-11.1-5.9-15.4-10.1-4.4-4.3-7.8-9.3-10.3-15.1-2.5-5.8-3.7-12-3.7-18.6 0-6.6 1.1-12.8 3.4-18.6 2.3-5.8 5.4-10.8 9.4-15.1 4-4.3 8.8-7.6 14.4-10.1 5.7-2.5 11.7-3.7 18.2-3.7zm22.7 39.1c-.2-1.9-.7-3.9-1.6-6.1-1-2.2-2.4-4.2-4.2-6-1.9-1.8-4.2-3.3-7-4.5-2.8-1.2-6.1-1.7-9.9-1.7-3.7 0-6.9.6-9.5 1.7-2.7 1.1-4.9 2.6-6.8 4.4s-3.3 3.7-4.2 5.9c-1 2.2-1.5 4.3-1.6 6.3h44.8zM807 410.3v90.4h-21.2v-11.8c-1.7 2.7-3.8 5-6.3 7.1-2.2 1.8-5 3.4-8.5 4.9-3.5 1.5-7.6 2.2-12.5 2.2-5.9 0-11.5-1.2-16.8-3.5-5.3-2.3-10-5.6-14-9.8-4-4.2-7.2-9.2-9.6-15-2.4-5.8-3.6-12.2-3.6-19.2s1.2-13.4 3.6-19.2c2.4-5.8 5.6-10.8 9.6-15 4-4.2 8.7-7.5 14-9.8 5.4-2.3 10.9-3.5 16.8-3.5 4.7 0 8.8.7 12.3 2.2 3.5 1.5 6.3 3.1 8.5 4.9 2.5 2.2 4.7 4.5 6.5 7.1v-11.9H807zM784.1 442c-1.4-2.3-3.1-4.4-5.2-6.3-1.8-1.5-4-3-6.7-4.3-2.7-1.3-5.9-2-9.5-2-3.8 0-7.3.7-10.4 2-3.1 1.3-5.8 3.2-7.9 5.5-2.2 2.4-3.8 5.1-5 8.3-1.2 3.2-1.7 6.6-1.7 10.3 0 3.7.6 7.1 1.7 10.3 1.2 3.2 2.8 5.9 5 8.3 2.1 2.3 4.8 4.2 7.9 5.5 3.1 1.3 6.6 2 10.4 2 3.7 0 6.9-.6 9.5-1.9 2.7-1.3 4.9-2.7 6.7-4.4 2.1-1.8 3.8-3.9 5.2-6.3v-27zM873.4 408c2 0 4 .2 5.9.5 1.9.3 3.6.7 5 1 1.6.5 3.2 1 4.8 1.3l-8 20.6c-.8-.2-1.7-.6-2.9-1-1-.3-2.2-.5-3.5-.8-1.4-.3-2.8-.4-4.5-.4-3.6 0-6.6.6-9.1 1.9-2.5 1.3-4.6 2.7-6.2 4.2-1.9 1.8-3.6 3.8-4.9 6.1v59.1h-23v-90.4h21.7v13.2c1.6-2.8 3.6-5.3 5.9-7.6 2-1.9 4.6-3.7 7.7-5.4 3.2-1.5 6.9-2.3 11.1-2.3zM949.2 408c4.3 0 8.5.8 12.5 2.3 4 1.5 7.5 3.8 10.6 6.7 3.1 2.9 5.5 6.5 7.3 10.7 1.8 4.2 2.8 9 2.8 14.5v58.6h-22.9V448c0-6.5-1.7-11.2-5.2-14.1-3.5-2.9-7.7-4.4-12.7-4.4-2.9 0-5.5.6-7.7 1.9-2.2 1.3-4.1 2.6-5.6 4-1.8 1.6-3.3 3.6-4.6 5.7v59.7h-22.9v-90.4h21.4v13.2c1.7-2.8 3.8-5.3 6.3-7.6 2.2-1.9 5-3.7 8.4-5.4 3.3-1.8 7.4-2.6 12.3-2.6z" />
									</g>
									<path
										fill="#C03A8E"
										d="M446.7 179.6v106.7H344.9v93.8H242v93.7H135.2v27l133.7.1v-93.8h102.9v-93.9h101.9V179.6z"
									/>
								</svg>
							</div>
						</h3>
						<p>
							I joined a small team of developers four months after{' '}
							<em>FutureLearn</em> was founded to help build a beta product fit
							for public unveiling in mid-Sept.
						</p>
						<p>
							Within the first 3 months, the user base quickly grew to over
							250,000 registered users. In Oct 2014, after just one year live,
							FutureLearn is fast approaching 1.5 million enrolments.
						</p>
						<p>
							The product is built in Ruby on Rails, using HAML and SASS on the
							front end. The team worked using Agile to gain real-time feedback
							from beta users to shape the product. I was one of two contracting
							Front Enders who helped build a scalable, modular, front end
							architecture which the maturing team can now inherit and build
							upon further.
						</p>
						<ul className="list-disc space-y-1 pl-5">
							<li>
								Worked with other developers to create a consistent Pattern
								Library.
							</li>
							<li>
								Collaborated closely with design/UX team to produce mobile-first
								designs.
							</li>
							<li>
								Worked with automated testing to ensure QA and confidence in
								site stability.
							</li>
							<li>
								Using Continuous Integration to deploy on average 5 times a day.
							</li>
							<li>
								Heavily involved in recruitment process for full time front end
								team.
							</li>
						</ul>
					</div>
				</section>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2012-06-28">Jun '12</time> &ndash;
							<time dateTime="2013-07-28">Jul '13 (Full-time employment)</time>
						</span>
					</div>
					<div>
						<h3>
							<img
								src="img/logos/othermedia.svg"
								alt="Other Media logo"
								className="mx-auto my-12 max-w-xs"
							/>
						</h3>
						<p>
							In my time with <em>Other Media</em> I was leading a small Front
							End team helping them transition to a more agile way of working
							(Scrum) to deliver high profile responsive projects for large
							enterprise clients such as Paul Smith and smaller high impact
							projects for highly visible clients such as Jasper Conran.
						</p>
						<ul className="list-disc space-y-1 pl-5">
							<li>
								Responsible for Front End build of Paul Smith redesign on Drupal
								with Magento eCommerce integration.
							</li>
							<li>
								Worked on sites for ZSL (London Zoo) & the English Cricket
								Board.
							</li>
							<li>
								Worked on pitch and early versions for 2013 Wildlife
								Photographer of the Year showcase.
							</li>
							<li>Involved in brainstorming and pitching for new work.</li>
							<li>
								Organised internal 'Learning Lunches' to encourage knowledge
								share within the agency.
							</li>
						</ul>
					</div>
				</section>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2007-06-28">Jun '07</time> &ndash;
							<time dateTime="2012-07-09">Jul '12 (Full-time employment)</time>
						</span>
					</div>
					<div>
						<h3>
							<div className="mx-auto my-12 h-[72px] w-[248px] max-w-xs">
								<svg width="248" height="72" xmlns="http://www.w3.org/2000/svg">
									<g fill="currentColor" fill-rule="evenodd">
										<path d="M134.325 46.055c0 7.665-9.539 7.21-9.539 7.21h-9.538V39.412h9.538c9.823-.056 9.539 6.643 9.539 6.643zm-19.077-27.763h7.268c7.55.398 7.266 6.018 7.266 6.018 0 6.983-8.346 7.097-8.346 7.097h-6.188V18.292zm17.317 15.84s6.529-2.782 6.472-10.163c0 0 .993-12.092-15.031-13.569H106.22v50.7h20.382s17.033.058 17.033-14.307c0 0 .397-9.765-11.071-12.66zM86.545.465h74.862V71.01H86.546V.465zM47.997 46.055c0 7.665-9.539 7.21-9.539 7.21H28.92V39.412h9.538c9.823-.056 9.539 6.643 9.539 6.643zM28.92 18.292h7.268c7.55.398 7.267 6.018 7.267 6.018 0 6.983-8.347 7.097-8.347 7.097H28.92V18.292zm17.317 15.84s6.529-2.782 6.472-10.163c0 0 .993-12.092-15.031-13.569H19.893v50.7h20.383s17.032.058 17.032-14.307c0 0 .398-9.765-11.071-12.66zM.217.465H75.08V71.01H.218V.465zM232.462 14.035v9.368s-9.142-5.621-19.247-5.735c0 0-18.85-.368-19.701 18.07 0 0-.682 16.96 19.474 17.926 0 0 8.46 1.022 19.928-6.302v9.709s-15.386 9.14-33.214 2.1c0 0-14.989-5.477-15.557-23.433 0 0-.625-18.467 19.36-24.599 0 0 5.338-2.044 14.933-1.136 0 0 5.734.568 14.024 4.032zM172.873 71.01h74.861V.465h-74.86V71.01z" />
									</g>
								</svg>
							</div>
						</h3>
						<p>
							I worked at the <em>BBC</em> for just under 5 years in total,
							progressing from a Junior Client Side Developer in 2007 at BBC
							Switch to spending my last eighteen months on the BBC iPlayer
							team.
						</p>
						<p>
							In this role, I worked within a large project team to deliver
							continuous improvements and features to the BBC's high profile TV
							& iPlayer website.
						</p>
						<p>
							I worked in an Agile team of ~10 developers, and was required to
							produce high performing, well written, object-oriented code on a
							daily basis.
						</p>
						<p>
							Working closely with my Project Manager, designers, other
							developers and testers within two-week release cycles, I help
							shape new features and improvements that enhanced the user
							experience for the millions of visitors that hit BBC iPlayer each
							week.
						</p>
						<p>
							We were one of the first teams within the BBC to embrace
							responsive, launching the Channels websites just before I left in
							June 2012, which went on to be the foundation for the revamped
							iPlayer site as it is today.
						</p>
						<ul className="list-disc space-y-1 pl-5">
							<li>
								In my five years, I also spent eighteen months on attachment to
								BBC Northern Ireland in Belfast where I had responsibility of
								supporting a large portfolio of legacy sites within a small
								technical team.
							</li>
							<li>Involved in producing live events sites for BBC Radio 1.</li>
							<li>
								Worked on high visibility products such as Human Planet, Battle
								of Britain and the Royal Wedding.
							</li>
						</ul>
					</div>
				</section>
				<h2 className="mb-6 text-3xl font-bold">Way back, in academia...</h2>
				<section className="space-y-4">
					<div>
						<span className="block border-t border-gray-400 pt-2 text-gray-600">
							<time dateTime="2003-09-18">Sept '03</time> &ndash;
							<time dateTime="2007-06-04">Jun '07</time>
						</span>
					</div>
					<div>
						<h3>
							<img
								src="img/logos/uu.svg"
								alt="University of Ulster logo"
								className="mx-auto my-12 max-w-xs"
							/>
						</h3>
						<p>
							Awarded 2:1 in{' '}
							<a
								href="http://scm.ulster.ac.uk/imd/"
								className="text-blue-600 underline"
							>
								BSc (Hons) Interactive Multimedia Design
							</a>
						</p>
						<p>
							Notable: Awarded place in SPEED Young Entrepreneurs Programme in
							Final Year.
						</p>
					</div>
				</section>
			</div>
		</>
	)
}
